// Зворотний зв'язок з розробником: форма в налаштуваннях → POST /feedback
// (воркер зберігає в D1 і одразу пушить адміну ботом — працює 24/7 без ПК).
// У TWA користувач ідентифікується initData, у звичайному браузері поле
// «контакт» заповнюється вручну.

import { API_BASE } from './api-base';
import { authHeaders } from './auth';

// Версия приложения подставляется на сборке из корневого package.json
// (vite define, barter-022) — бамп версии только в package.json.
export const APP_VERSION: string = __APP_VERSION__;

export type FeedbackCategory = 'bug' | 'idea' | 'question';

export interface FeedbackPayload {
  category: FeedbackCategory;
  message: string;
  contact?: string;
}

export async function sendFeedback(payload: FeedbackPayload): Promise<void> {
  const res = await fetch(`${API_BASE}/feedback`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(await authHeaders()) },
    body: JSON.stringify({
      ...payload,
      pageUrl: typeof window !== 'undefined' ? window.location.href.slice(0, 300) : '',
      appVersion: APP_VERSION,
    }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
}
